<template>
  <div>
    <main class="fix">
      <section class="breadcrumb__area breadcrumb__bg">
        <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100" :style="{ backgroundImage: `url('assets/img/banner/banner1.png')` }"></div>
        <div class="container">
          <div class="row mt-5">
            <div class="col-lg-6">
              <div class="breadcrumb__content">
                <h2 class="title">Foto</h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);" @click="$router.push('/')">Beranda</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Foto</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="breadcrumb__shape">
          <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
        </div>
      </section>
      <section class="blog_area mt-5">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-6" v-for="data in list_data" :key="data.id">
              <div class="project__item-two">
                <div class="project__thumb-two">
                  <img :src="file_path + data.file" alt="Apexa" />
                </div>
                <div class="project__content-two">
                  <h2 class="title"><a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal"
                      @click="selectData(data)">{{ data.judul }}</a></h2>
                </div>
              </div>
            </div>

            <div class="pagination-wrap mt-40 mb-5">
              <nav aria-label="Page navigation example">
                <ul class="pagination list-wrap">
                  <li class="page-item"><a class="page-link" href="javascript:void(0);" @click="btn_prev" id="pref"><i class="fas fa-angle-double-left"></i></a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_first }}</a></li>
                  <li class=""><a class="page-link border-0" href="javascript:void(0);">-</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_last }}</a></li>
                  <li class="page-item next-page"><a class="page-link" href="javascript:void(0);" @click="btn_next"><i class="fas fa-angle-double-right"></i></a></li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Lampiran</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <div class="text-center">
                    <img class="img-responsive" :src="file_path + form.file" alt="clients">
                  </div>
                  <hr>
                  <h5><b>{{ form.judul }}</b></h5>
                  <hr>
                  <p>{{ form.deskripsi }}</p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="blog__post-tag-two" data-bs-dismiss="modal">Keluar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project__shape-wrap-two">
          <img class="dark-opacity" src="assets/img/project/h2_project_shape.png" alt="Apexa" data-aos="fade-left" data-aos-delay="400" />
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import UMUM from '../../library/umum'

export default {

  data() {
    return {
      data_load: false,
      form: {
        id: '',
        judul: '',
        deskripsi: '',
        file: '',
        unit_kerja: '',
        status: '',
        createBy: '',
        createAt: '',
      },
      id: '',
      cek_load_data: true,
      file_old: "",
      file_path: this.$store.state.url.URL_APP + "uploads/",
      UMUM: UMUM,

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
    }
  },
  methods: {
    getView: function () {
      fetch(this.$store.state.url.URL_FOTO + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          kategori: this.kategori,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          this.cek_load_data = false;
          // console.log(res_data);
        });
    },

    selectData: function (data) {
      console.log(data);
      this.form = {
        id: data.id,
        judul: data.judul,
        deskripsi: data.deskripsi,
        file: data.file,
        unit_kerja: data.unit_kerja,
        status: data.status,
        createBy: data.createBy,
        createAt: data.createAt,
      };
    },
    ke_alamat: function (data) {
      window.open(data);
    },

    mdl_exit: function () {
      this.judul = "";
      this.uraian = "";
      this.file = "";
      this.file_old = "";
    },

    // ================== PAGINASI ====================
    alertku: function (type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {

      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {

      this.page_first = 1;
      this.getView();
    },
    onFileSelected: function (event) {
      this.form.file = event.target.files[0];
    },
    convert_tgl: function (dateString) {
      var date = new Date(dateString);
      return date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear();
    },
    // ================== PAGINASI ====================

    // ================== MODAL ====================
    buka_modal: function (modalku) {
      var modal = document.getElementById(modalku);
      modal.style.display = "block";
    },

    tutup_modal: function (modalku) {
      var modal = document.getElementById(modalku);
      modal.style.display = "none";
    },

    // ================== MODAL ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {

    this.getView();

  }
};
</script>
